import OrbelineImg from "../assets/images/projects/orbeline.png";
import SorellaImg from "../assets/images/projects/sorella.png";
import TequilaDesignImg from "../assets/images/projects/tequila_design.png";
import TokaImg from "../assets/images/projects/toka.png";
import StradeImg from "../assets/images/projects/strade.png";
import GrupoAcmeImg from "../assets/images/projects/grupo_acme.png";
import PoloHospitalityImg from "../assets/images/projects/polo_hospitality.png";
import MonteverdeImg from "../assets/images/projects/monteverde.png";
import UvaqImg from "../assets/images/projects/uvaq.png";

export const projects = [
  {
    title: 'Sistema de gestión interna "Orbeline"',
    description:
      "Sistema que permite la emisión de pólizas, facturación y procesamiento de pagos, así como la gestión de comisiones para vendedores.",
    image: OrbelineImg,
    techs: ["Laravel", "ReactJS", "SQL", "Facturapi", "Stripe"],
    link: "https://portal.orbeline.com",
  },
  {
    title: 'Ecommerce de vestidos "Sorella"',
    description:
      "Plataforma que gestiona la venta y renta de vestidos, con integración de sistemas de pago y logística de entrega y recolección.",
    image: SorellaImg,
    techs: ["Laravel", "ReactJS", "TypeScript", "Storybook", "SQL", "Stripe"],
    link: "https://e-sorella.com",
  },
  {
    title: 'Ecommerce de botellas personalizadas "Tequila Design"',
    description:
      "Ofrece personalización de botellas de tequila con vista previa, pagos con tarjeta y opción de Kueski Pay.",
    image: TequilaDesignImg,
    techs: ["PHP", "jQuery", "HTML", "SASS", "Shopify"],
    link: "https://mx.tequiladesign.com",
  },
  {
    title: 'Sitio web de la empresa "Toka"',
    description:
      "Presenta información sobre las tarjetas ofrecidas, permite la consulta de saldos y promociones, y facilita la realización de cotizaciones.",
    image: TokaImg,
    techs: ["PHP", "jQuery", "HTML", "SASS"],
    link: "https://www.toka.com.mx",
  },
  {
    title: 'Ecommerce de sneakers personalizados "Strade"',
    description:
      "Permite personalizar sneakers por imagen o color, con vista previa y pagos mediante tarjeta, PayPal y Metamask.",
    image: StradeImg,
    techs: ["PHP", "jQuery", "HTML", "SASS", "Shopify"],
  },
  {
    title: 'Aplicación de acceso para personal "Grupo ACME"',
    description:
      "Registra el ingreso y salida de colaboradores mediante QR, visualiza horarios y calcula las horas trabajadas.",
    image: GrupoAcmeImg,
    techs: ["ExpressJS", "MongoDB", "React Native"],
  },
  {
    title: 'Plataforma de alquiler de bienes de lujo "Polo Hospitality"',
    description:
      "Facilita la renta de bienes de lujo, validando disponibilidad y cantidad de personas, también ofrece la consulta de servicios de terceros como transporte, alimentación y amenidades.",
    image: PoloHospitalityImg,
    techs: ["ExpressJS", "VueJS", "MongoDB", "Stripe"],
    link: "https://polohospitality.mx",
  },
  {
    title: 'Plataforma de renta de cabañas "Monteverde"',
    description:
      "Permite la renta de cabañas, validando disponibilidad y número de personas, con tarifas ajustadas según temporada y descuentos definidos por el administrador.",
    image: MonteverdeImg,
    techs: ["PHP", "jQuery", "HTML", "SASS", "Conekta"],
    link: "https://reserva.monteverde.com.mx",
  },
  {
    title: 'Plataforma universitaria estudiantil "UVAQ"',
    description:
      "Muestra información sobre las especialidades ofrecidas, así como noticias y actividades de la universidad.",
    image: UvaqImg,
    techs: ["PHP", "jQuery", "HTML", "CSS"],
    link: "https://www.uvaq.edu.mx",
  },
];
